import _classCallCheck from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import DataCard from "./components/DataCard.vue";
import MyButton from "./components/MyButton.vue";
import { I18nService } from "./i18n";

var CourseManage = /*#__PURE__*/function (_Vue) {
  _inherits(CourseManage, _Vue);

  var _super = _createSuper(CourseManage);

  function CourseManage() {
    var _this;

    _classCallCheck(this, CourseManage);

    _this = _super.apply(this, arguments);
    _this.i18n = I18nService.getLang("front-courseMana");
    _this.i18nCommon = I18nService.getLang("commonField");
    _this.labelList = [{
      name: "张三",
      value: "zs"
    }, {
      name: "李四",
      value: "ls"
    }, {
      name: "王五",
      value: "ww"
    }];
    _this.stateList = [];
    _this.courseLsit = [{
      key: 1,
      url: "",
      title: "大数据入门",
      state: 0,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }, {
        key: 3,
        name: "鸿蒙"
      }]
    }, {
      key: 2,
      url: "",
      title: "大数据入门",
      state: 1,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }]
    }, {
      key: 3,
      url: "",
      title: "大数据入门",
      state: 2,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }]
    }, {
      key: 4,
      url: "",
      title: "大数据入门",
      state: 3,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }, {
        key: 3,
        name: "鸿蒙"
      }]
    }, {
      key: 5,
      url: "",
      title: "大数据入门",
      state: 3,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }, {
        key: 3,
        name: "鸿蒙"
      }]
    }, {
      key: 6,
      url: "",
      title: "大数据入门",
      state: 1,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }, {
        key: 3,
        name: "鸿蒙"
      }]
    }, {
      key: 7,
      url: "",
      title: "大数据入门",
      state: 2,
      chapter: "5章7节",
      tag: [{
        key: 1,
        name: "大数据"
      }, {
        key: 2,
        name: "5G"
      }, {
        key: 3,
        name: "鸿蒙"
      }]
    }];
    _this.currency = "";
    return _this;
  }

  _createClass(CourseManage, [{
    key: "created",
    value: function created() {
      I18nService.event.$on(I18nService.I18nEventEnum.CLOCALE, this.changeLocale);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getInitData();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      I18nService.event.$off(I18nService.I18nEventEnum.CLOCALE, this.changeLocale);
    }
  }, {
    key: "changeLocale",
    value: function changeLocale() {
      this.i18n = I18nService.getLang("front-courseMana");
      this.i18nCommon = I18nService.getLang("commonField");
    }
  }, {
    key: "getInitData",
    value: function getInitData() {}
  }, {
    key: "handleCurrencyChange",
    value: function handleCurrencyChange() {}
  }, {
    key: "onSearch",
    value: function onSearch() {}
  }]);

  return CourseManage;
}(Vue);

CourseManage = __decorate([Component({
  components: {
    DataCard: DataCard,
    MyButton: MyButton
  }
})], CourseManage);
export default CourseManage;